import { useSearch } from '@tanstack/react-router';

import { useOverviewPerformance } from '../../shared/hooks/use-insight-overview';

import { useSharedDateRange } from '@/shared/hooks/use-shared-date-range';
import { usePublicFilter } from '../../shared/public-filter/use-public-filter';
import { StatCard } from '../../shared/ui/stat-card';

export function MetricsSummary() {
  const { q } = useSearch({ strict: false }) as { q: string };
  const { dateRange } = useSharedDateRange();
  const { publicFilter } = usePublicFilter(q);
  const { data: performance, isLoading } = useOverviewPerformance({
    queryId: q,
    startDate: dateRange.startDate,
    endDate: dateRange.endDate,
    limit: 5,
    publicFilter,
  });

  return (
    <div className="grid gap-4 lg:grid-cols-3">
      <StatCard
        title="Total volume"
        value={performance?.totalVolume ?? 0}
        platformStatistic={
          performance?.trends?.map((trend) => ({
            platform: trend.platform,
            value: trend.data.reduce((acc, curr) => acc + curr.count, 0),
          })) ?? []
        }
        isLoading={isLoading}
      />
      <StatCard
        title="View"
        value={performance?.totalViews ?? 0}
        platformStatistic={
          performance?.trends?.map((trend) => ({
            platform: trend.platform,
            value: trend.data.reduce((acc, curr) => acc + curr.view, 0),
          })) ?? []
        }
        isLoading={isLoading}
      />
      <StatCard
        title="Total engagement"
        value={performance?.totalEngagements ?? 0}
        platformStatistic={
          performance?.trends.map((trend) => ({
            platform: trend.platform,
            value: trend.data.reduce(
              (acc, curr) => acc + curr.like + curr.comment + curr.shared,
              0,
            ),
          })) ?? []
        }
        isLoading={isLoading}
      />
    </div>
  );
}
